import api from './api';

// Response types matching backend API
export interface FitCoinBalance {
  purchasedBalance: number;
  dailyAllowance: number;
  totalAvailable: number;
  eligibleForDailyAllowance: boolean;
  dailyAllowanceResetAt: string;
  nairaValue: number;
  pricing: {
    coinValueNgn: number;
    tryonCostCoins: number;
  };
  updatedAt: string;
}

export interface FitCoinTransaction {
  id: string;
  user_id: string;
  amount: number;
  balance_after: number;
  transaction_type: 'credit' | 'debit';
  reason: string;
  reference_id: string | null;
  created_at: string;
}

export interface TransactionResponse {
  transactions: FitCoinTransaction[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    total_pages: number;
  };
}

export interface DebitRequest {
  amount: number;
  reason: string;
  reference_id?: string;
}

class FitCoinService {
  /**
   * Get user's current FitCoin balance
   * GET /v1/fitcoin/balance
   */
  async getBalance(): Promise<FitCoinBalance> {
    const response = await api.get('/fitcoin/balance');
    return response.data;
  }

  /**
   * Get transaction history with pagination
   * GET /v1/fitcoin/transactions
   */
  async getTransactions(page = 1, limit = 20): Promise<TransactionResponse> {
    const response = await api.get('/fitcoin/transactions', {
      params: { page, limit }
    });
    return response.data;
  }

  /**
   * Deduct coins for virtual try-on
   * POST /v1/fitcoin/debit
   */
  async debitCoins(data: DebitRequest): Promise<FitCoinBalance> {
    const response = await api.post('/fitcoin/debit', data);
    return response.data;
  }

  /**
   * Helper: Deduct coins for virtual try-on with post reference
   */
  async deductForTryOn(postId: string, amount = 6): Promise<FitCoinBalance> {
    return this.debitCoins({
      amount,
      reason: 'virtual_tryon',
      reference_id: `post_${postId}_${Date.now()}`
    });
  }
}

export default new FitCoinService();
